import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { OBSERVABILITY_SINK, type ObservabilityTiming } from './observability-sink';

@Injectable({ providedIn: 'root' })
export class ObservabilityService {
  private readonly sink = inject(OBSERVABILITY_SINK);

  error(source: string, error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      this.sink.error({ source, message: error.statusText || 'http error', status: error.status });
      return;
    }

    this.sink.error({ source, message: error instanceof Error ? error.message : String(error) });
  }

  failure(source: string, message: string, status?: number): void {
    this.sink.error(status === undefined ? { source, message } : { source, message, status });
  }

  timing(event: ObservabilityTiming): void {
    this.sink.timing(event);
  }
}
